import { IGetLocationsListResponseSchema } from '../repositories/countryside-constructors/entities/v1_entities/GetLocationsListResponseSchema';
import { ILocationItem } from '../types/buildersLocations';

export const prepareBuildersLocations = ({ locations }: IGetLocationsListResponseSchema): ILocationItem[] => {
  return locations.sort((a, b) => a.name.localeCompare(b.name));
};
